import React from "react";
import { QRCodeCanvas } from "qrcode.react";
import ActionBar from "../pages/ActionBar";

const MediaModal = ({
  open,
  item,
  folder,
  onClose,
  API_BASE,
  settings,
  submitMessage,
  handleDownload,
  handleShare,
}) => {
  if (!open || !item) return null;

  const mediaUrl = `${API_BASE}/api/fs-load-image?token=${encodeURIComponent(
    folder
  )}&image=${encodeURIComponent(item.file)}`;
  const shareUrl = `https://bleepshare.tech/s/${item.short_code}`;

  return (
    <div className="media-modal-backdrop" onClick={onClose}>
      <div
        className="media-modal"
        onClick={(e) => e.stopPropagation()}
      >
        <button className="media-close" onClick={onClose}>
          &times;
        </button>

        {item.file_type === "image" ? (
          <img src={mediaUrl} alt="" className="modal-media" />
        ) : (
          <video
            src={mediaUrl}
            className="modal-media"
            controls
            autoPlay
          />
        )}

        <div className="media-modal-actions">
          {item.short_code && (
            <div className="modal-qr">
              <QRCodeCanvas value={shareUrl} size={70} includeMargin={false} />
            </div>
          )}

          {settings && (
            <ActionBar
              settings={settings}
              item={item}
              submitMessage={submitMessage}
              handleDownload={handleDownload}
              handleShare={handleShare}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default MediaModal;
